const state = {
  websocket: null,
  wsReconnectAttempts: 0,
  established: false,
  reconnecting: false,
  usersCountInterval: null
}

const getters = {
  getWsReconnectAttempts (state) {
    return state.wsReconnectAttempts
  },
  getIsReconnecting(state) {
    return state.reconnecting
  },
  getWebsocket(state) {
    return state.websocket
  },
  getEstablished(state) {
    return state.established
  }
}

const mutations = {
  increaseWsReconnectAttempts(state) {
    state.wsReconnectAttempts++
  },
  truncateAttempts(state) {
    state.wsReconnectAttempts = 0
  },
  setReconnecting (state, value) {
    state.reconnecting = value
  },
  setWebsocket(state, newState) {
    state.websocket = newState
  },
  setEstablished(state, newState) {
    state.established = newState
  },
  setUserCountInterval (state) {
    const store = this
    state.usersCountInterval = setInterval(() => {
      if (state.established) {
        // shouldn't be there; dispatch from mutations - bad idea
        store.dispatch('sendWsMsg', {'cmd': 'count', 'body': ''})
      }
    }, 15000)
  },
  clearUserCountInterval (state) {
    state.usersCountInterval = null;
  }
}

const actions = {
  connectWebsocket ({commit, dispatch, getters}, vm) {
    const ws = new WebSocket(vm.$settings.websocket || getters.getServer)
    ws.onopen = () => {
      commit('setWebsocket', ws)
      commit('setEstablished', true)
      commit('truncateAttempts')

      // FIXME: send json not string
      const authBody = {
        token: vm.$settings.authtoken || getters.getToken,
        domain: vm.$settings.websocket ? vm.$settings.websocket.split('/')[2] : getters.getDomain
      }
      dispatch('sendWsMsg', {cmd: 'auth', body: JSON.stringify(authBody)})
      dispatch('sendWsMsg', {cmd: 'join',
        body: vm.$settings.roomid || getters.getRoomId})
      if (!getters.getIsReconnecting) dispatch('sendWsMsg', {cmd: 'get_greetings', body: ''})
      else {
        dispatch('setReconnecting', false)
        const msgs = getters.getMessages
        const msg = msgs.length ? msgs[msgs.length -1 ] : null
        if (msg) dispatch('sendWsMsg', {cmd: 'get_msgs_after', body: `${msg.id}`})
      }
    }
    ws.onclose = () => {
      commit('setWebsocket', null)
      commit('setEstablished', false)
      commit('increaseWsReconnectAttempts')
      if (getters.getWsReconnectAttempts <= 20) {
        setTimeout(function () {
          dispatch('connectWebsocket', vm);
        }, 3000);
      }
    }
    ws.onerror = () => {
      dispatch('setReconnecting', true)
      ws.close()
    }
    ws.onmessage = (e) => {
      const response = JSON.parse(e.data)
      dispatch('handleResponse', response)
    }
  },
  sendWsMsg({ state, getters }, payload) {
    if (getters.getEstablished) state.websocket.send(JSON.stringify(payload))
  },
  setReconnecting(context, newState) {
    context.commit('setReconnecting', newState)
  },
  handleResponse({commit, dispatch, getters}, payload) {
    switch (payload.cmd) {
      case "count":
        commit('setUsersCount', payload.body)
        break
      case "msg":
        dispatch('prepareMessage', payload)
        if (payload.type === 'text' && getters.getIsScrolling) dispatch('setNewMessageReceived', true)
        break
      case "clientInfo":
        // FIXME: body should be already json
        var body = JSON.parse(payload.body)
        dispatch('setMyId', body.uid)
        if (body.rights.moderate) {
          dispatch('makeMeModarator').then(
              dispatch('clearUserCountInterval').then(
              dispatch('setUserCountInterval'))
          )
        }
        break
      case "greetings":
        // FIXME: body should be already json
        dispatch('handleGreetings', JSON.parse(payload.body))
        break
      case "history":
        var defCallback = () => {}
        var callback = getters.getHistoryCallback || defCallback
        var promise = new Promise((resolve) => {
          // FIXME: body should be already json
          if (dispatch('handleHistory', JSON.parse(payload.body))) {
            resolve();
          }
        });
        promise.then(() => {
          callback()
          dispatch('setHistoryCallback', null)
          dispatch('setGettingOldMsgs', false)
        });
        break
      case "users":
        // FIXME: body should be already json
        var users = JSON.parse(payload.body)
        commit('setUsersCount', users.length)
        dispatch('setUsers', users)
        break
      case "user_joined":
        // FIXME: body should be already json
        dispatch('createUser', JSON.parse(payload.body))
        break
      case "user_left":
        // FIXME: should receive int
        dispatch('deleteUser', parseInt(payload.body))
        break
      default:
        break
    }
  },
  setUserCountInterval ({commit}) {
    commit('setUserCountInterval')
  },
  clearUserCountInterval({commit}) {
    commit('clearUserCountInterval')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
